import React from 'react';
import ThumbNew from '../../../../assets/img/premium/icon-thumb-new.svg';
import './PackageBenefit.css';

export type Benefit = {
  icon_url: string;
  is_new: boolean;
  title: string;
  description: string;
};

type PropTypes = {
  benefit: Benefit[];
  title: string;
  photo: string;
  isBundleFeatured?: boolean;
};

const PackageBenefit: React.FC<PropTypes> = ({ title, benefit, photo }) => {
  return benefit.length ? (
    <div className="premium-feature">
      {photo && <img src={photo} alt="" />}
      <div className="premium-feature__list">
        <h3 className="list-title">{title}</h3>
        <ul>
          {benefit.map((item) => (
            <li key={item.title}>
              {item.icon_url && (
                <div className="thumb">
                  <img src={item.icon_url} alt="" width={48} />
                </div>
              )}
              <div className="content">
                <strong className="title">
                  {item.title} {item.is_new && <img src={ThumbNew} alt="" />}
                </strong>
                <p className="desc">{item.description}</p>
              </div>
            </li>
          ))}
        </ul>
      </div>
    </div>
  ) : (
    <></>
  );
};

export default PackageBenefit;
